module.exports = __webpack_public_path__ + "8427ab38523c6fb178c7b7e7d3d68476.png";